import type { RouteObject } from "react-router";

import { Outlet } from "react-router";
import { lazy, Suspense } from "react";

import { CONFIG } from "src/global-config";
import { DashboardLayout } from "src/layouts/dashboard";

import { LoadingScreen } from "src/components/loading-screen";

import { AuthGuard } from "src/auth/guard";

import { usePathname } from "../hooks";

// ----------------------------------------------------------------------

const DashboardPage = lazy(() => import("src/pages/dashboard/dashboard"));
const UserPage = lazy(() => import("src/pages/dashboard/user"));
const FeedbackPage = lazy(() => import("src/pages/dashboard/feedback"));
const ChangePasswordPage = lazy(
  () => import("src/pages/dashboard/change-password")
);

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const dashboardRoutes: RouteObject[] = [
  {
    path: "/",
    element: CONFIG.auth.skip ? (
      dashboardLayout()
    ) : (
      <AuthGuard>{dashboardLayout()}</AuthGuard>
    ),
    children: [
      { path: "dashboard", element: <DashboardPage />, index: true },
      { path: "users", element: <UserPage /> },
      { path: "feedbacks", element: <FeedbackPage /> },
      { path: "change-password", element: <ChangePasswordPage /> },
      // {
      //   path: "group",
      //   children: [
      //     { element: <PageFour />, index: true },
      //     { path: "five", element: <PageFive /> },
      //     { path: "six", element: <PageSix /> },
      //   ],
      // },
    ],
  },
];
